<div id="alert-root"></div>
<app-loading></app-loading>
<app-menu *ngIf="!isWebview" [ngClass]="{'black-Friday': isBlackFriday}" [showJaSouClienteBtn]="showJaSouClienteBtn"
  [showAlterarEnderecoBtn]="showAlterarEnderecoBtn" [showCarrinho]="showCarrinho"></app-menu>

<!-- Banner Vitrine -->
<div *ngIf="router.url.includes('/monte-sua-combinacao')">
  <ng-container *ngIf="this.bannersBytechnology">
    <div id="bannersBytechnology" class="mdn-Swiper mdn-Swiper--banner" data-mdn-slider-delay="5000"
      data-mdn-slider-per-view-mobile="1" data-mdn-slider-per-view-tablet="1" data-mdn-slider-per-view-small-desktop="1"
      data-mdn-slider-per-view="1" data-mdn-auto-play="true">
      <div id="swiperWrapper" class="mdn-Swiper-wrapper" [ngClass]="{
                'errorBanner': errorBanner,
                webview: isWebview
              }">
        <div *ngFor="let banner of this.bannersBytechnology"
          class="mdn-Banner mdn-Banner--slide mdn-Swiper-slide mdn-Banner--left mdn-Banner--transparent">
          <div class="mdn-Banner-wrapper">
            <div class="mdn-Banner-item" [ngClass]="{webview: isWebview}">
              <button class="banner-button" (click)="clickBanner(banner)">
                <img id="bannerId" [src]="banner.image">
              </button>
            </div>
          </div>
        </div>
      </div>
        <!-- Bullets -->
        <div id="swiperPagination" class="mdn-Swiper-pagination"></div>
    </div>
  </ng-container>
</div>
<!-- Fim Banner Vitrine -->

<main>
  <div id="app-container" class="mdn-Container">
    <router-outlet></router-outlet>
  </div>

  <div class="mdn-Container btn-next-area area-btn-cobertura d-xl-none"
    *ngIf="router.url.includes('/monte-sua-combinacao')">
    <div *ngIf="!isWebview; else webviewBtn">
      <div id="preencher-dados" class="btn-next d-sm-block d-md-none d-lg-none d-xl-none no-padding" [ngClass]="{
          active: this.quantidadeCarrinho > 0,
          disabled: this.quantidadeCarrinho === 0,
          stickyy: isSticky,
          buttonDynamicPosition: hasCookiesHtml
        }">
        <div>
          <a (click)="continuaCompra()" (keydown.enter)="continuaCompra()" title="Próximo" class="gtm-link-event"
            [attr.data-gtm-event-category]="
              gtmCategory + ':geral:preencher-dados'
            " data-gtm-event-action="clique:finalizar" data-gtm-event-label="preencher-dados">Preencher Dados</a>
        </div>
      </div>
    </div>
     <ng-template #webviewBtn>
        <div
          id="ver-pedido"
          (click)="carrinho.toggleCart()"
          class="btn-cart d-sm-block d-md-block d-lg-block d-xl-none no-padding"
        >
          <div class="btn-cart-info">
            <div class="btn-cart-price">
                <p class="mdn-Text mdn-Text--body mdn-Text--inverse">Valor total</p>
                <div class="btn-cart-price-monthly">
                  <h3 class="mdn-Heading mdn-Heading--inverse mdn-Heading--sm">{{ valorTotal / 100 | currency }}</h3>
                  <p class="mdn-Text mdn-Text--body mdn-Text--inverse">/mês</p>
                </div>
            </div>
            <div class="btn-cart-text">
                <span>Ver Pedido</span>
                <span class="mdn-Icon-cima mdn-Icon--md" role="img"></span>
            </div>
          </div>
        </div>
      </ng-template>
  </div>

  <ng-container *ngIf="shouldDisplayComponent()">
    <!-- <div class="c-push-claro-movel" id="pushClaroMovel" [style.display]="showButton ? 'none' : 'block'">
      <div class="c-push-claro-movel__wrapper" (click)="onCloseClaroMovel()">
        <span class="c-push-claro-movel__wrapper--close mdn-Icon-fechar mdn-Icon--sm"></span>
      </div>
      <img class="c-push-claro-movel__animation" src="https://a.storyblok.com/f/223917/200x200/398f3c75f7/snipped-claro-fibra.png" alt="Claro Fibra, clique aqui"/>
    </div> -->
    <button *ngIf="showButton" (click)="onClickClaroFibra()" class="mdn-Button mdn-Button--iconText mdn-Button--primary mdn-Button--lg">
      <!-- <em class="mdn-Icon-direita mdn-Icon--md" aria-hidden="true"></em> -->
      <span>Nova geração Claro Fibra</span>
    </button>
  </ng-container>
</main>
<div id="template-footer">
  <div *ngIf="
      router.url.includes('/checkout/confirmacao') &&
      showReguaTransacionalOfertaPlanoMovel
    " id="regua-transacional-oferta-plano-movel">
    <div class="mdn-Container">
      <h2 class="mdn-Heading mdn-Heading--sm">
        Confira essa oferta especial para você!
      </h2>
      <app-regua-transacional-oferta-plano-movel></app-regua-transacional-oferta-plano-movel>
    </div>
  </div>

  <div class="mdn-Container" *ngIf="
      !router.url.includes('/checkout/confirmacao')
    ">
    <div class="mdn-Row">
      <div class="mdn-Col-xs-12">
        <app-accordion *ngIf="showDisclaimer" [list]="accordionList" [id]="'disclaimer'"></app-accordion>
      </div>
    </div>
  </div>

  <app-footer *ngIf="!isWebview" [ngClass]="{'black-Friday': isBlackFriday}"></app-footer>
</div>

